<template>
  <div class="gallery">
    <div class="gallery-main card">
      <img :src="images[activeIndex]" :alt="alt" />
      <span v-if="images.length > 1" class="gallery-counter muted">
        {{ activeIndex + 1 }} / {{ images.length }}
      </span>
    </div>
    <div v-if="images.length > 1" class="gallery-thumbs">
      <button
        v-for="(img, i) in images"
        :key="i"
        type="button"
        class="thumb"
        :class="{ active: i === activeIndex }"
        :aria-label="`صورة ${i + 1}`"
        @click="activeIndex = i"
      >
        <img :src="img" :alt="`${alt} — ${i + 1}`" />
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

defineProps({
  images: { type: Array, required: true },
  alt: { type: String, default: "صورة العقار" },
});

const activeIndex = ref(0);
</script>

<style scoped>
.gallery-main {
  position: relative;
  padding: 0;
  overflow: hidden;
}

.gallery-main img {
  width: 100%;
  aspect-ratio: 16 / 10;
  object-fit: cover;
  display: block;
}

.gallery-counter {
  position: absolute;
  bottom: 12px;
  inset-inline-start: 12px;
  background: color-mix(in srgb, var(--surface-card) 92%, transparent);
  padding: 4px 12px;
  border-radius: var(--radius-md);
  font-size: 0.8125rem;
  font-weight: 500;
}

.gallery-thumbs {
  display: flex;
  gap: 8px;
  margin-top: 12px;
  overflow-x: auto;
  padding-bottom: 4px;
}

.thumb {
  flex-shrink: 0;
  width: 80px;
  height: 56px;
  padding: 0;
  border: 2px solid transparent;
  border-radius: var(--radius-md);
  overflow: hidden;
  cursor: pointer;
  background: none;
  opacity: 0.7;
  transition: opacity var(--motion), border-color var(--motion);
}

.thumb.active,
.thumb:hover {
  opacity: 1;
  border-color: var(--brand);
}

.thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.thumb:focus-visible {
  outline: 2px solid var(--brand);
  outline-offset: 2px;
}
</style>
